const { library, config } = require('@fortawesome/fontawesome-svg-core');
import '@fortawesome/fontawesome-svg-core/styles.css';
config.autoAddCss = false; // Tell Font Awesome to skip adding the CSS automatically since it's being imported above

// Only the icons this app actually references are registered. Importing the whole `fas`/`far`/`fab`
// sets pulls ~1.7MB into every page's load size, so only import what we use. To use a new icon, add it
// to the import list below and to the icon library initialization below.
// If an icon renders blank (Font Awesome logs "Could not find icon" to the console), then it needs to be added here.
import {
  faAddressBook,
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faArchive,
  faArrowRight,
  faArrowUpRightFromSquare,
  faBars,
  faBasketShopping,
  faBell,
  faBook,
  faBookmark,
  faBriefcase,
  faBuilding,
  faBuildingCircleXmark,
  faCalendarCheck,
  faCalendarDays,
  faCaretDown,
  faCaretLeft,
  faCaretRight,
  faCaretUp,
  faCertificate,
  faChartLine,
  faCheck,
  faCheckCircle,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChildReaching,
  faCircle,
  faCircleArrowRight,
  faCircleCheck,
  faCircleExclamation,
  faCircleInfo,
  faCircleQuestion,
  faCircleXmark,
  faClipboard,
  faClipboardCheck,
  faClipboardList,
  faClipboardQuestion,
  faClock,
  faClose,
  faCloud,
  faCog,
  faComment,
  faDollarSign,
  faDoorOpen,
  faDownload,
  faEdit,
  faEllipsis,
  faEllipsisVertical,
  faEnvelope,
  faExchange,
  faExchangeAlt,
  faExclamationCircle,
  faExternalLinkAlt,
  faEye,
  faFile,
  faFileArrowDown,
  faFileArrowUp,
  faFileExport,
  faFileLines,
  faFilePdf,
  faFilePen,
  faFlag,
  faFolderOpen,
  faFutbol,
  faGavel,
  faGear,
  faGlobe,
  faGraduationCap,
  faHand,
  faHandHoldingDollar,
  faHandsHolding,
  faHandshake,
  faHandshakeSimple,
  faHeart,
  faHome,
  faHospital,
  faHouse,
  faHouseUser,
  faIdCard,
  faInbox,
  faInfoCircle,
  faLanguage,
  faLaptop,
  faLink,
  faListCheck,
  faLocationArrow,
  faLocationDot,
  faLock,
  faMagnifyingGlass,
  faMagnifyingGlassMinus,
  faMagnifyingGlassPlus,
  faMale,
  faMap,
  faMapMarker,
  faMapMarkerAlt,
  faMessage,
  faMinus,
  faMinusSquare,
  faMobile,
  faMobileAlt,
  faMobileScreenButton,
  faNewspaper,
  faPaperPlane,
  faPassport,
  faPaste,
  faPencil,
  faPenSquare,
  faPhone,
  faPlug,
  faPlus,
  faPlusSquare,
  faPrint,
  faQuestion,
  faQuestionCircle,
  faQuoteLeft,
  faRefresh,
  faReply,
  faRetweet,
  faRocket,
  faSearch,
  faShare,
  faShareNodes,
  faShareSquare,
  faShield,
  faShieldHalved,
  faSignInAlt,
  faSitemap,
  faSortDown,
  faSortUp,
  faSpellCheck,
  faSpinner,
  faSquareCheck,
  faStar,
  faStreetView,
  faTableColumns,
  faTag,
  faTags,
  faTh,
  faThumbsDown,
  faThumbsUp,
  faTimes,
  faTrash,
  faTrashAlt,
  faTriangleExclamation,
  faUpRightFromSquare,
  faUpload,
  faUser,
  faUserDoctor,
  faUserGear,
  faUserPlus,
  faUsers,
  faUserSlash,
  faUtensils,
  faVideo,
  faWheelchair,
  faXmark
} from '@fortawesome/free-solid-svg-icons';

// The following imports the `regular` style icons, whereas the block above imported the `solid` style icons.
// To prevent namespace collisions, we alias the icons (i.e. faBookmark => farBookmark) which allows us to
// use either style in components (i.e.  icon={['fas', 'bookmark']} OR  icon={['far', 'bookmark']}))
import {
  faBookmark as farBookmark,
  faCheckCircle as farCheckCircle,
  faCircleCheck as farCircleCheck,
  faComment as farComment,
  faHeart as farHeart,
  faNoteSticky as farNoteSticky,
  faPenToSquare as farPenToSquare,
  faSmile as farSmile,
  faSquare as farSquare,
  faStar as farStar
} from '@fortawesome/free-regular-svg-icons';

import {
  faFacebookSquare as fabFacebookSquare,
  faGithubSquare as fabGithubSquare,
  faGoogle as fabGoogle,
  faInstagramSquare as fabInstagramSquare,
  faLinkedin as fabLinkedin,
  faMicrosoft as fabMicrosoft,
  faTwitterSquare as fabTwitterSquare,
  faYoutubeSquare as fabYoutubeSquare
} from '@fortawesome/free-brands-svg-icons';

const initializeIconLibrary = () => {
  library.add(
    faAddressBook,
    faAngleDown,
    faAngleLeft,
    faAngleRight,
    faArchive,
    faArrowRight,
    faArrowUpRightFromSquare,
    faBars,
    faBasketShopping,
    faBell,
    faBook,
    faBookmark,
    faBriefcase,
    faBuilding,
    faBuildingCircleXmark,
    faCalendarCheck,
    faCalendarDays,
    faCaretDown,
    faCaretLeft,
    faCaretRight,
    faCaretUp,
    faCertificate,
    faChartLine,
    faCheck,
    faCheckCircle,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faChildReaching,
    faCircle,
    faCircleArrowRight,
    faCircleCheck,
    faCircleExclamation,
    faCircleInfo,
    faCircleQuestion,
    faCircleXmark,
    faClipboard,
    faClipboardCheck,
    faClipboardList,
    faClipboardQuestion,
    faClock,
    faClose,
    faCloud,
    faCog,
    faComment,
    faDollarSign,
    faDoorOpen,
    faDownload,
    faEdit,
    faEllipsis,
    faEllipsisVertical,
    faEnvelope,
    faExchange,
    faExchangeAlt,
    faExclamationCircle,
    faExternalLinkAlt,
    faEye,
    faFile,
    faFileArrowDown,
    faFileArrowUp,
    faFileExport,
    faFileLines,
    faFilePdf,
    faFilePen,
    faFlag,
    faFolderOpen,
    faFutbol,
    faGavel,
    faGear,
    faGlobe,
    faGraduationCap,
    faHand,
    faHandHoldingDollar,
    faHandsHolding,
    faHandshake,
    faHandshakeSimple,
    faHeart,
    faHome,
    faHospital,
    faHouse,
    faHouseUser,
    faIdCard,
    faInbox,
    faInfoCircle,
    faLanguage,
    faLaptop,
    faLink,
    faListCheck,
    faLocationArrow,
    faLocationDot,
    faLock,
    faMagnifyingGlass,
    faMagnifyingGlassMinus,
    faMagnifyingGlassPlus,
    faMale,
    faMap,
    faMapMarker,
    faMapMarkerAlt,
    faMessage,
    faMinus,
    faMinusSquare,
    faMobile,
    faMobileAlt,
    faMobileScreenButton,
    faNewspaper,
    faPaperPlane,
    faPassport,
    faPaste,
    faPencil,
    faPenSquare,
    faPhone,
    faPlug,
    faPlus,
    faPlusSquare,
    faPrint,
    faQuestion,
    faQuestionCircle,
    faQuoteLeft,
    faRefresh,
    faReply,
    faRetweet,
    faRocket,
    faSearch,
    faShare,
    faShareNodes,
    faShareSquare,
    faShield,
    faShieldHalved,
    faSignInAlt,
    faSitemap,
    faSortDown,
    faSortUp,
    faSpellCheck,
    faSpinner,
    faSquareCheck,
    faStar,
    faStreetView,
    faTableColumns,
    faTag,
    faTags,
    faTh,
    faThumbsDown,
    faThumbsUp,
    faTimes,
    faTrash,
    faTrashAlt,
    faTriangleExclamation,
    faUpRightFromSquare,
    faUpload,
    faUser,
    faUserDoctor,
    faUserGear,
    faUserPlus,
    faUsers,
    faUserSlash,
    faUtensils,
    faVideo,
    faWheelchair,
    faXmark,
    farBookmark,
    farCheckCircle,
    farCircleCheck,
    farComment,
    farHeart,
    farNoteSticky,
    farPenToSquare,
    farSmile,
    farSquare,
    farStar,
    fabFacebookSquare,
    fabGithubSquare,
    fabGoogle,
    fabInstagramSquare,
    fabLinkedin,
    fabMicrosoft,
    fabTwitterSquare,
    fabYoutubeSquare
  );
};

export default initializeIconLibrary;
